module.exports = __webpack_public_path__ + "static/img/user2.70cb071e.png";